import React, {useEffect} from 'react'
import SqftUseCanvas from './SqftUseCanvas'
// import sqftConfig from "./../store/sqftConfig";
// import sqftEventManager from "./../store/sqftEventManager";
// import SqftGrid from "./render/SqftGrid";
//import sqftShapeManager from "../store/sqftShapeManager";
import sqftEventManager from "../store/sqftEventManager";
import SqftStore from "../store/sqftStore";
import {connect} from "react-redux";
import {injectIntl} from "react-intl";

const SqftCanvas = props => {

  const { options, visualizersLoadedLength, fabricatorData, sqftVisited, intl, quotes, activeQuoteIndex, ...rest } = props;
  // const { context, ...moreConfig } = options;
  const { context } = options;
  const canvasRef = SqftUseCanvas(
    sqftEventManager.renderEvents,
    {context},
    visualizersLoadedLength,
    fabricatorData,
    sqftVisited,
    intl,
    quotes,
    activeQuoteIndex,
  );

  //todo sqft-react remove
  //console.log('eventManager', sqftEventManager);
  //console.log('shapeManager', sqftShapeManager);
  //console.log('sqftStore', SqftStore);

  useEffect(() => {
    SqftStore.canvas.width = canvasRef.current.clientWidth;
    SqftStore.canvas.height = canvasRef.current.clientHeight;
  }, [canvasRef]);

  useEffect(() => {
    return () => {
      sqftEventManager.canvas.isWithEventManager = false;
    }
  }, [])

  return (
    <div>
      <canvas id='workspace' className='workspace-canvas' height="800" width="800" ref={canvasRef} {...rest}/>
      {/*<SqftGrid canvasRef={canvasRef}/>*/}
    </div>
  )
};

const mapStateToProps = (store) => ({
  visualizersLoadedLength: store.serverState.visualizersLoaded,
  fabricatorData: store.fabricatorState,
  sqftVisited: store.sqftState.sqftFeaturesPopup.visited,
  quotes: store.quotesState.quotes,
  activeQuoteIndex: store.quotesState.activeQuoteIndex,
});

const mapDispatchToProps = {
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(SqftCanvas)
);
